import {IUser, RolesAccount} from '@/app/auth';
import {COnboardingTypeStates} from '@/app/main/onboarding/constants/OnboardingConstants';

import {E_ADDRESS_TYPE} from './constants';
import {IAddress, IVerificationUserState} from './entities';

export const mapAddress = (
  data: IVerificationUserState,
  addressType: E_ADDRESS_TYPE,
  role: string,
): IAddress => {
  if (role === RolesAccount.PARENT) {
    return data?.addresses?.find(item => item.type_address === addressType);
  }
  const familyBillingAddress = data.family
    ?.find(member => member.roles.includes(RolesAccount.PARENT))
    ?.addresses?.find(
      addressItem => addressItem?.type_address === E_ADDRESS_TYPE.BILLING,
    );
  return familyBillingAddress;
};

export const mapVerificationUserToProfile = (
  verificationUser: IVerificationUserState,
): IUser => {
  const role = verificationUser?.roles?.[0] as IUser['role'];
  return {
    id: verificationUser?.uuid,
    firstName: verificationUser?.first_name,
    lastName: verificationUser?.last_name,
    name: verificationUser?.name,
    email: verificationUser?.email,
    phone: verificationUser?.phone,
    role: role,
    notify_me: verificationUser?.notify_me,
    parentStatus: undefined,
    userCreatedAt: verificationUser?.created_at,
    metadata: verificationUser?.metadata,
    kycStatus: undefined,
    onboarding: verificationUser?.onboarding || COnboardingTypeStates.PENDING,
    onboarding_version: verificationUser.onboarding_version,
    billingAddress: mapAddress(verificationUser, E_ADDRESS_TYPE.BILLING, role),
    shippingAddress: mapAddress(
      verificationUser,
      E_ADDRESS_TYPE.SHIPPING,
      role,
    ),
    referral_code_owned: verificationUser?.referral_code?.code,
    family: verificationUser.family,
    familyId: verificationUser.family_id,
    // The backend returns '' when no source of funds is set yet; normalize to
    // undefined so the UI can treat it as "not selected".
    sourceOfFunds: verificationUser?.bank_info?.source_of_funds || undefined,
  };
};
